<div *wlAccessControl="getAccessControlForElement(securityElementNames.Profiles_Module); else noAccess">
  <div class="mct-flex-gt-xs mct-row-gt-xs mct-flex-lt-sm mct-col-lt-sm"
    id="profile-edit-header-bar">
    <span class="profile-edit-210px-gt-xs" id="profile-edit-header">
      {{ 'profiles.edit.title' | translate | titlecase }}
    </span>
    <div class="mct-flex mct-row mct-justify-center-gt-xs mct-items-center-gt-xs mct-justify-start-lt-sm mct-items-center-lt-sm mct-gap-5">
      <wl-profile-type-icon [isMember]="profile.Member" [isOrg]="profile.OrgInd" [profileId]="profile.ProfileId"
        [memberTypeIconColor]="profile.MemberTypeIconColor"></wl-profile-type-icon>
      <span><strong>{{ profile.ReportName }}</strong> ({{ profile.ProfileId }})</span>
    </div>
    <div
      class="mct-flex-gt-xs mct-row-gt-xs mct-flex-lt-sm mct-col-lt-sm mct-justify-end-gt-xs mct-items-center-gt-xs mct-justify-end-lt-sm mct-items-stretch-lt-sm mct-gap-5 mct-flex-1-1-0 profile-edit-40pct-lt-sm"
      *ngIf="!hideSaveButtons">
      <wl-busy [show]="isSaving"></wl-busy>
      <button pButton type="button" class="atlas-btn atlas-btn-danger tall" type="button" (click)="cancelClick()"
        title="{{ 'common.cancel' | translate | titlecase }}">
        {{ 'common.cancel' | translate | titlecase }}
      </button>
      <button class="atlas-btn atlas-btn-primary tall" type="button" (click)="saveClick()"
        title="{{ 'profiles.edit.save-and-continue' | translate | titlecase }}"
        [disabled]="isSaving || validateProfile()">
        {{ 'profiles.edit.save-and-continue' | translate | titlecase }}
      </button>
      <button data-cy="btnEditProfileSave" class="atlas-btn atlas-btn-primary tall" type="button"
        (click)="saveClick(true)" title="{{ 'profiles.edit.save-and-continue' | translate | titlecase }}"
        [disabled]="isSaving || validateProfile()">
        {{ 'profiles.edit.save-profile' | translate | titlecase }}
      </button>
    </div>
  </div>
  <div class="tabs-wrapper">
    <wlx-tabs #tabsContainer class="no-absolute">
      <wlx-tab #relationshipTab [title]="'profiles.edit.relationship.title' | translate | titlecase"
        [hidden]="!relatedProfileId" [selected]="relatedProfileId">
        <div class="profile-tab-container">
          <wl-profile-edit-relationship [profileId]="profileId" [relatedProfileId]="relatedProfileId"
            [profileRelationId]="profileRelationId"></wl-profile-edit-relationship>
        </div>
      </wlx-tab>
      <wlx-tab [title]="'profiles.edit.general-information.title' | translate | titlecase" selected="!relatedProfileId">
        <div class="profile-tab-container">
          <wl-profile-edit-general [ngModel]="profile" (ngModelChange)="generalEditChange($event)"
            [profileId]="profileId"></wl-profile-edit-general>
        </div>
      </wlx-tab>
      <wlx-tab [title]="'profiles.edit.membership-information.title' | translate | titlecase"
        *wlAccessControl="getAccessControlForElement(securityElementNames.ProfileMember_Tab)">
        <div class="profile-tab-container">
          <wl-profile-edit-membership [(ngModel)]="memberInformation" [isModal]="isModal"></wl-profile-edit-membership>
        </div>
      </wlx-tab>
      <wlx-tab [title]="'profiles.edit.additional-addresses.title' | translate | titlecase"
        *wlAccessControl="getAccessControlForElement(securityElementNames.ProfileAddresses_Tab)">
        <div class="profile-tab-container">
          <wl-profile-edit-address-list [profileId]="profileId"></wl-profile-edit-address-list>
        </div>
      </wlx-tab>
      <wlx-tab [title]="'profiles.edit.additional-phones.title' | translate | titlecase"
        *wlAccessControl="getAccessControlForElement(securityElementNames.ProfilePhone_Number_Tab)">
        <div class="profile-tab-container">
          <wl-profile-edit-phone-list [profileId]="profileId"></wl-profile-edit-phone-list>
        </div>
      </wlx-tab>
      <wlx-tab [title]="'profiles.edit.additional-emails.title' | translate | titlecase">
        <div class="profile-tab-container">
          <wl-profile-edit-emails [profileId]="profileId"></wl-profile-edit-emails>
        </div>
      </wlx-tab>
      <wlx-tab #listingsTab [title]="'profiles.edit.listings.title' | translate | titlecase"
        *wlAccessControl="getAccessControlForElement(securityElementNames.ProfileListings_Tab)">
        <ng-template wlLazyTabContent>
          <div class="profile-tab-container">
            <wl-profile-edit-listing-list [profileId]="profileId" [profile]="profile"
              [(tabIsSelected)]="listingsTab.selected"
              (saveAndRedirectClicked)="saveClick(false)"></wl-profile-edit-listing-list>
          </div>
        </ng-template>
      </wlx-tab>
      <wlx-tab [title]="'profiles.edit.embedded-video.title' | translate | titlecase">
        <wl-profile-edit-embedded-video [profileId]="profileId"></wl-profile-edit-embedded-video>
      </wlx-tab>
      <wlx-tab [title]="'profiles.edit.social-media.title' | translate | titlecase">
        <div class="profile-tab-container">
          <wl-profile-edit-social-media [profileId]="profileId"></wl-profile-edit-social-media>
        </div>
      </wlx-tab>
      <wlx-tab [title]="'profiles.edit.affiliation-codes.title' | translate | titlecase"
        *wlAccessControl="getAccessControlForElement(securityElementNames.ProfileAffiliations_Tab)">
        <div class="profile-tab-container">
          <wl-profile-edit-affiliations [profileId]="profileId"
            [isMember]="memberInformation.Member"></wl-profile-edit-affiliations>
        </div>
      </wlx-tab>
      <wlx-tab [title]="'profiles.edit.billing.title' | translate | titlecase"
        *wlAccessControl="getAccessControlForElement(securityElementNames.ProfileBilling_Tab)">
        <div class="profile-tab-container">
          <wl-profile-edit-billing-list [profileId]="profileId"></wl-profile-edit-billing-list>
        </div>
      </wlx-tab>
      <wlx-tab [title]="'profiles.edit.web-portal-credentials.title' | translate | titlecase"
        *wlAccessControl="getAccessControlForElement(securityElementNames.ProfilePortal_Tab)">
        <div class="profile-tab-container">
          <wl-profile-edit-web-portal-credentials [profile]="profile"></wl-profile-edit-web-portal-credentials>
        </div>
      </wlx-tab>
      <wlx-tab [title]="'profiles.edit.custom-fields.title' | translate | titlecase"
        *wlAccessControl="getAccessControlForElement(securityElementNames.ProfileCustom_Info_Tab)">
        <div class="profile-tab-container">
          <wl-profile-edit-custom-fields [profileId]="profileId"></wl-profile-edit-custom-fields>
        </div>
      </wlx-tab>
      <wlx-tab *ngIf="showProfileTypeTab" [title]="'profiles.edit.profile-type.title' | translate | titlecase">
        <div class="profile-tab-container">
          <wl-profile-edit-profile-type [profile]="profile"></wl-profile-edit-profile-type>
        </div>
      </wlx-tab>
      <wlx-tab *ngIf="showNahb" [title]="'profiles.edit.nahb' | translate | uppercase">
        <div class="profile-tab-container">
          <wl-nahb-profile-type-edit [profileId]="profileId"></wl-nahb-profile-type-edit>
        </div>
      </wlx-tab>
      <wlx-tab [title]="'profiles.edit.notes' | translate | titlecase">
        <div class="profile-tab-container">
          <wl-profile-edit-notes [profileId]="profileId"></wl-profile-edit-notes>
        </div>
      </wlx-tab>
      <wlx-tab [title]="'profiles.edit.delete-profile.title' | translate | titlecase"
        *wlAccessControl="getAccessControlForElement(securityElementNames.Delete_Profile)">
        <div class="profile-tab-container">
          <wl-profile-edit-delete [profile]="profile"></wl-profile-edit-delete>
        </div>
      </wlx-tab>
    </wlx-tabs>
  </div>
  <div class="mct-flex mct-row mct-justify-end mct-items-center mct-gap-5" *ngIf="!hideSaveButtons">
    <wl-busy [show]="isSaving"></wl-busy>
    <button pButton type="button" class="atlas-btn atlas-btn-danger tall" type="button" (click)="cancelClick()"
      title="{{ 'common.cancel' | translate | titlecase }}">
      {{ 'common.cancel' | translate | titlecase }}
    </button>
    <button class="atlas-btn atlas-btn-primary tall" type="button" (click)="saveClick()"
      title="{{ 'profiles.edit.save-and-continue' | translate | titlecase }}" [disabled]="isSaving || validateProfile()">
      {{ 'profiles.edit.save-and-continue' | translate | titlecase }}
    </button>
    <button class="atlas-btn atlas-btn-primary tall" type="button" (click)="saveClick(true)"
      title="{{ 'profiles.edit.save-and-continue' | translate | titlecase }}" [disabled]="isSaving || validateProfile()">
      {{ 'profiles.edit.save-profile' | translate | titlecase }}
    </button>
  </div>

  <p-dialog #membershipLevelChangedModal [(visible)]="showModal" modal="true" [closable]="false"
    styleClass="atlas-dialog-m" [focusOnShow]="false" [contentStyle]="{ 'max-height': '75vh' }">
    <p>
      {{ 'profiles.edit.membership-information.change-membership-level-message' | translate }}
    </p>
    <ul class="list-unstyled">
      <li>
        <label>
          <input type="radio" name="eventBenefitDiscoutType" [value]="dialogResponseEnum.Yes"
            [(ngModel)]="dialogResponse" />
          {{ 'profiles.edit.membership-information.auto-migrate-message' | translate }}
        </label>
      </li>
      <li>
        <label>
          <input type="radio" name="eventBenefitDiscoutType" [value]="dialogResponseEnum.No"
            [(ngModel)]="dialogResponse" />
          {{ 'profiles.edit.membership-information.manual-migrate-message' | translate }}
        </label>
      </li>
    </ul>
    <ng-template pTemplate="footer">
      <wl-busy *ngIf="isSaving" [show]="isSaving"></wl-busy>
      <label>
        <button pButton type="button" class="btn btn-primary" [disabled]="isSaving"
          (click)="handleChangeMembershipLevelModalContinueClick()">
          {{ 'common.continue' | translate | titlecase }}
        </button>
      </label>
    </ng-template>
  </p-dialog>
</div>
<ng-template #noAccess>
  {{ 'common.phrases.access-denied-for-user-role' | translate | ucfirst }}
</ng-template>

<p-confirmDialog #cd key="runAutoAssignMembershipLevelCD"
  header="{{ 'profiles.edit.membership-information.auto-assign-confirm-header' | translate | ucfirst }}"
  icon="pi pi-exclamation-triangle">
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="cd.onReject()">{{ 'common.cancel' |
      translate | uppercase }}</button>
    <button pButton type="button" class="atlas-btn btn-primary" (click)="cd.onAccept()">
      {{ 'profiles.edit.update-profile' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>
